import type { Logger } from './types'
import { AppLogger } from './AppLogger'

export type { Logger, LoggerUser, LoggerErrorContext } from './types'
export type { LoggerProvider } from './providers/types'

export const logger: Logger = new AppLogger([])
